/* eslint-disable import/prefer-default-export */
import * as React from 'react'

export const useEffectUpdate = (
  effect: React.EffectCallback,
  deps?: React.DependencyList
) => {
  const isFirstRender = React.useRef(true)

  React.useEffect(() => {
    if (!isFirstRender.current) {
      effect()
    }
  }, deps)

  React.useEffect(() => {
    isFirstRender.current = false
  }, [])
}
